<template>
  <footer class="border-t border-gray-200 bg-white">
    <div class="mx-auto max-w-4xl px-6 py-8 text-sm text-gray-500">
      © {{ new Date().getFullYear() }} Nevcap. All rights reserved.
    </div>
  </footer>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'LightFooter',
});
</script>
